import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { combineLatestWith, distinctUntilChanged, Observable } from 'rxjs';
import { DataRef, Utensil } from '../../../shared/models/dataref.model';
import { FormControl } from '@angular/forms';
import { AutocompleteChoice } from '../../../shared/components/new-form-field-select-autocomplete/new-form-field-select-autocomplete.component';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'dcp-utensils-group-control',
  templateUrl: './utensil-group-control.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UtensilGroupControlComponent implements OnInit {
  @Input()
  public allUtensils$: Observable<Utensil[]>;

  @Input()
  public listOfUtensilsCtrl: FormControl<string[] | null>;

  public allChoices$: Observable<AutocompleteChoice[]>;
  public selectedChoices$: Observable<AutocompleteChoice[]>;

  ngOnInit(): void {
    const allUtensilsChange$ = this.allUtensils$.pipe(distinctUntilChanged());

    this.allChoices$ = allUtensilsChange$.pipe(map((allUtensils) => this.mapToAutocompleteChoices(allUtensils)));

    this.selectedChoices$ = this.listOfUtensilsCtrl.valueChanges.pipe(
      startWith(this.listOfUtensilsCtrl.value),
      distinctUntilChanged(),
      map((listOfUtensilKeys) => new Set(listOfUtensilKeys)),
      combineLatestWith(this.allChoices$),
      map(([setOfUtensilKeys, allChoices]) => allChoices.filter((choice) => setOfUtensilKeys.has(choice.key))),
    );
  }

  updateChosenUtensilsInForm(utensilChoices: AutocompleteChoice[]): void {
    const listOfUtensilKeys = utensilChoices.map((choice) => choice.key);
    this.setControlAndMarkAsDirty(this.listOfUtensilsCtrl, listOfUtensilKeys);
  }

  private mapToAutocompleteChoices(utensils: DataRef[]): AutocompleteChoice[] {
    return utensils.map((utensil) => {
      const utensilChoice: AutocompleteChoice = {
        key: utensil.key,
        label: utensil.translatedName ?? utensil.key,
      };

      return utensilChoice;
    });
  }
  private setControlAndMarkAsDirty<T>(control: FormControl<T>, valueToSet: T): void {
    control.setValue(valueToSet);
    control.markAsDirty();
  }
}
